import React from "react"
import { useTranslation } from "react-i18next"
import { ModalBody } from "reactstrap"
import { BaseModal, IModalBase, IModalControlProps, ModalFooter } from "swiipe.portal.shared"
import "./ModalError.scss"

export interface IModalError extends IModalBase {
    type: "error"
    errorMessage: string
}

const ModalError = ({ title, errorMessage, callback, ...otherProps }: IModalError & IModalControlProps) => {
    const { t } = useTranslation()
    return (
        <BaseModal
            {...otherProps}
            modalClassName="error-modal"
            callback={callback}
            centered
            title={title || t("common.error_title")}
        >
            <ModalBody>
                <div>
                    <p className="mb-0 text-center errormessage-text">{errorMessage}</p>
                </div>
            </ModalBody>
            <ModalFooter rightButton={{ onClick: async () => callback("accepted"), text: t("common.close") }} />
        </BaseModal>
    )
}

export default ModalError
